import QueryAttribute from "./QueryAttribute";
export type CachedElement = {
  id: string;
  attributes: Record<string, QueryAttribute>;
  children?: Record<string, string>;
  childrenOfType?: Record<string, Record<string, string>>;
  parentId?: string;
};
/**
 * Element cache should be holding the values of each separate attribute
 * {
 *   "SC.123.456"
 * }
 */
const activeElementCache: Record<string, CachedElement> = {};
export const getElementCacheEntry = (id: string) => activeElementCache[id];
export const getElementCache = () => activeElementCache;
export const getOrCreateEntry = (id: string) => {
  activeElementCache[id] = activeElementCache[id] || {
    id,
    attributes: {},
  };
  return activeElementCache[id];
};
export const clearElementCache = (ids?: string[]) => {
  const listToDelete = ids || Object.keys(activeElementCache);
  listToDelete.forEach((key) => {
    delete activeElementCache[key];
  });
};
export const getElementDepthToParent = (
  parentId: string,
  id: string
): number | null => {
  if (id === parentId) return 0;
  let elem = getElementCacheEntry(id);
  if (elem) {
    let depth = 0;
    while (elem && elem.parentId) {
      depth += 1;
      if (elem.parentId === parentId) return depth;
      elem = getElementCacheEntry(elem.parentId);
    }
  }
  return null;
};
